import React from "react";
import { Route, Switch } from "react-router-dom";
import Home from "./Home";
import Header from "./Header";
import NewQuestion from "./NewQuestion";
import Login from "./Login";
import * as userActions from "../redux/actions/userActions";
import { connect } from "react-redux";
import LeaderBoard from "./LeaderBoard";
import AnswerQuestion from "./AnswerQuestion";
import Page404 from "./Page404";
import AboutPage from "./AboutPage";

class App extends React.Component {
  render() {
    try {
      return (
        <>
          <Header />
          <Switch>
            <Route exact path="/" component={Home} />
            <Route path="/login" component={Login} />
            <Route path="/add" component={NewQuestion} />
            <Route path="/leaderboard" component={LeaderBoard} />
            <Route
              exact
              path="/questions/:questionId"
              component={AnswerQuestion}
            />
            <Route path="/about" component={AboutPage} />
            <Route render={() => <Page404 />} />
          </Switch>
        </>
      );
    } catch {
      return <Route exact path="/" component={Login} />;
    }
  }
}

const mapStateToProps = (state:any) => {
  return {
    users: state.userReducer.users,
    loggedUser: state.userReducer.loggedUser,
    isLogged: state.userReducer.loggedUser.id ? true : false,
  };
};

const mapDispatchToProps = (dispatch:any) => {
  return {
    getAllUsers: () => dispatch(userActions.getAllUsers()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
